import * as yup from "yup";

export const swarmsSchema = yup.object().shape({
    BteId:          yup.number().required(),
    instructions:   yup.string(),
    code:   yup.string(),
    rewardTypeId:   yup.number().required(),
    BuyManagerId:   yup.number().required(), 
    StrategyTypeId: yup.number().required(),
    reward:         yup.string().required('The reward field is mandatory').matches(/^\d*\.?\d{0,2}$/, 'The value must be a number with up to two decimal places or an integer').test('is-positive', 'The value must be positive', (value) => parseFloat(value) > 0),    SalesDate:      yup.string().required(),
    isNow:          yup.boolean()
});

export const runningSwarmSchema = yup.object().shape({
    bteId:          yup.number().required(),
    instructions:   yup.string(),
    code:   yup.string(),
    rewardTypeId:   yup.number().required(),
    buyManagerId:   yup.number().required(), 
    strategyTypeId: yup.number().required(),
    reward:         yup.string().required('The reward field is mandatory').matches(/^\d*\.?\d{0,2}$/, 'The value must be a number with up to two decimal places or an integer').test('is-positive', 'The value must be positive', (value) => parseFloat(value) > 0),    
    salesDate:      yup.string().required(),
    isNow:          yup.boolean()
});

export const notRunningSwarmSchema = yup.object().shape({
    BteId:          yup.number(),
    instructions:   yup.string(),
    rewardTypeId:   yup.number().required(),
    BuyManagerId:   yup.number(),
    StrategyTypeId: yup.number(),
    reward:         yup.string().required('The reward field is mandatory').matches(/^\d*\.?\d{0,2}$/, 'The value must be a number with up to two decimal places or an integer').test('is-positive', 'The value must be positive', (value) => parseFloat(value) > 0),    
    SalesDate:      yup.string(),
    isNow:          yup.boolean()
});
